import { inject } from 'inversify-props';
import IAuthService from "services/IAuthService";
import { ICampaign, Campaign, Format } from "../../../adnami_ts_models/app";
import { AxiosPromise } from "axios";

class CampaignService {
  @inject() private authService: IAuthService;

  host: string = `${window.location.protocol}//${window.location.host}`;
  api: string = "/api/genericcampaign/";

  constructor(api: string = null) {
    if (api) this.api = api;
  }

  saveCampaign(campaign: ICampaign) {
    const endpoint = this.host + this.api;
    const response = this.authService.post(endpoint, campaign);
    return response;
  }

  getCampaign(campaignId: number): AxiosPromise<Campaign> {
    const endpoint = this.host + this.api + campaignId;
    const response = this.authService.getV2(endpoint);
    return response;
  }

  updateCampaign(campaign: ICampaign): AxiosPromise<Campaign> {
    const endpoint = this.host + this.api;
    const response = this.authService.put(endpoint, campaign);
    return response;
  }

  publishCampaign(campaign: ICampaign) {
    const endpoint = this.host + this.api + "publish";
    const response = this.authService.post(endpoint, campaign);
    return response;
  }

   getPlaceholderFormats(canvasBannerPlaceholderId: any, formatIdIncluded: string = null) {
    let queryString = new URLSearchParams();
    queryString.append("canvasBannerPlaceholderId", canvasBannerPlaceholderId);

    if (formatIdIncluded) {
        queryString.append("formatIdIncluded", formatIdIncluded);
    }

    const endpoint = this.host + this.api + "placeholderformats" + "?" + queryString.toString();
    const response = this.authService.getV2(endpoint);
    return response;
  }
}

export default new CampaignService();
